import type { Sort } from '../../models/components/sort'
import type { ToolingState, ToolState } from '../../models/store/tooling/tooling.state'
import type { ToolingSortingComposable, ToolingSortingComposableParams } from './type'
// @ts-strict-ignore
import { getCurrentInstance, ref } from 'vue'
import { TOOLING_CONSTS } from '../../store/tooling/tooling.consts'
import { useFeature } from '../use-feature'
import { mapActions, mapGetters } from '../utils'

export function useToolingSorting(
  params?: ToolingSortingComposableParams,
): ToolingSortingComposable {
  const {
    proxy: { $store },
  } = getCurrentInstance()

  const { featureId } = useFeature()

  const { tools } = mapGetters<ToolingState['tools']>($store, TOOLING_CONSTS.moduleName, {
    tools: TOOLING_CONSTS.getters.state,
  })

  const tool: ToolState = tools.value[featureId.value]

  const sort: ToolingSortingComposable['sort'] = ref(tool?.sort ?? params?.defaultSortValue)

  const toolingStore = mapActions($store, TOOLING_CONSTS.moduleName, {
    setSorting: TOOLING_CONSTS.actions.setSorting,
  })

  const setToolingSorting = (newSort: Sort): void => {
    sort.value = newSort
    toolingStore.setSorting({ tool: featureId.value, sort: newSort })
  }

  return { sort, setToolingSorting }
}
